/**
 * Autogenerated file don't modify
 */
(function () {
var tsBuild = (function (exports) {
    'use strict';

    var moyaToggle = MoyaContainer.get('core.toggle');
    var accordionCounter = 0;
    MoyaContainer.register('ext.accordion', function () {
        return {
            init: Accordion.create,
            getStylesheetUrl: Accordion.getStylesheetUrl,
        };
    });
    var Accordion = /** @class */ (function () {
        function Accordion() {
        }
        Accordion.create = function () {
            return new Accordion().run();
        };
        Accordion.getLocalThemePath = function () {
            var themePath = '/static/themes/main';
            Array.from(document.styleSheets)
                .filter(function (e) { return e.href && e.href.indexOf('/static/themes') !== -1; })
                .filter(function (e) { return e.href && e.href.indexOf('theme.css') !== -1; })
                .map(function (e) { return e.href; })
                .forEach(function (stylesheet) {
                themePath = stylesheet.substring(0, stylesheet.lastIndexOf('/')).replace(location.origin, '');
            });
            return themePath;
        };
        Accordion.getStylesheetUrl = function () {
            var layout = Accordion.getAccordionLayout();
            if (!layout) {
                return;
            }
            if (layout === 'local') {
                return Accordion.getLocalThemePath() + '/accordion.css';
            }
            return '/static/local/ext-accordion/css/' + layout + '.css';
        };
        Accordion.prototype.run = function () {
            var _this = this;
            Accordion.loadStyles().then(function () {
                _this.createAccordions();
                _this.checkInitHash();
            });
        };
        Accordion.loadStyles = function () {
            var stylesheetUrl = Accordion.getStylesheetUrl();
            if (!stylesheetUrl) {
                return Promise.resolve();
            }
            return MoyaLoader.css(stylesheetUrl);
        };
        Accordion.getAccordionLayout = function () {
            if (document.body.dataset.accordion) {
                return document.body.dataset.accordion;
            }
            var layout = '';
            document.body.classList.forEach(function (name) {
                if (name.startsWith('accordion')) {
                    layout = name.replace('accordion-', '');
                    return;
                }
            });
            return layout;
        };
        Accordion.prototype.createAccordions = function () {
            var _this = this;
            document.querySelectorAll('.accordion:not(.ready)').forEach(function (el) {
                var button = Accordion.wrapTitleInButton(el);
                var wrapper = _this.wrapContent(el);
                _this.createToggle(button, wrapper);
                _this.fixNestedMaxHeight(wrapper);
                el.classList.add('ready');
            });
        };
        Accordion.wrapTitleInButton = function (el) {
            var title = el.querySelector('*:first-child');
            var button = document.createElement('button');
            button.innerHTML = title.innerHTML;
            el.id = 'accordion-' + Accordion.getAnchorIdFromTitle(button.innerText);
            title.innerHTML = '';
            title.parentNode.insertBefore(button, title);
            title.remove();
            return button;
        };
        Accordion.prototype.wrapContent = function (el) {
            var wrapper = document.createElement('div');
            wrapper.classList.add('wrap');
            wrapper.id = 'accordion-' + (++accordionCounter);
            wrapper.dataset.moyaComponent = "core.max-height";
            MoyaComponents.run(wrapper);
            this.wrapElements(el.querySelectorAll(':scope >*:not(:first-child)'), wrapper);
            return wrapper;
        };
        Accordion.prototype.wrapElements = function (elements, wrapper) {
            if (elements && elements.length) {
                elements[0].parentNode.insertBefore(wrapper, elements[0]);
                elements.forEach(function (child) { return wrapper.appendChild(child); });
            }
        };
        Accordion.prototype.createToggle = function (button, wrapper) {
            moyaToggle.create(button, wrapper, 'accordion' + accordionCounter, {
                'onOpen': function (toggle) {
                    toggle.getOpenElement().parentElement.classList.add('open');
                    Accordion.updateHash(Accordion.getAnchorIdFromTitle(button.innerText));
                },
                'onClose': function (toggle) {
                    toggle.getOpenElement().parentElement.classList.remove('open');
                    Accordion.updateHash('');
                },
                'closeOnBodyClick': false,
            });
        };
        Accordion.prototype.fixNestedMaxHeight = function (wrapper) {
            wrapper.addEventListener('transitionend', function () {
                window.dispatchEvent(new Event('resize'));
            });
        };
        Accordion.updateHash = function (hash) {
            history.replaceState(null, null, '#' + hash);
        };
        Accordion.getAnchorIdFromTitle = function (title) {
            var anchor = title.trim().toLowerCase(), special = {
                á: 'a',
                ð: 'd',
                é: 'e',
                í: 'i',
                ó: 'o',
                ú: 'u',
                ý: 'y',
                þ: 'th',
                æ: 'ae',
                ö: 'o',
            }, r;
            for (var i in special) {
                r = new RegExp(i, "g");
                anchor = anchor.replace(r, special[i]);
            }
            return anchor.replace(/[^a-zA-Z0-9\s]/g, "").replace(/\s+/g, '-');
        };
        Accordion.prototype.checkInitHash = function () {
            var _this = this;
            var sections = document.querySelectorAll('.accordion');
            if (!sections.length) {
                return;
            }
            var hash = location.hash;
            if (hash) {
                this.openParentAccordions(hash);
                this.scrollToAccordion(hash);
            }
            document.querySelectorAll("a[href*=\"#\"]:not([href=\"#\"])").forEach(function (el) {
                el.addEventListener('click', function () {
                    if (location.pathname.replace(/^\//, '') !== el.pathname.replace(/^\//, '')
                        || location.hostname !== el.hostname) {
                        return;
                    }
                    _this.scrollToAccordion(el.hash);
                });
            });
        };
        Accordion.prototype.scrollToAccordion = function (hash) {
            var _a;
            var id = hash.replace('#', '#accordion-');
            var section = document.querySelector(id);
            if (!section) {
                return;
            }
            var btn = section.querySelector('button[aria-haspopup]');
            if (!btn) {
                return;
            }
            if (!section.classList.contains('open')) {
                btn.click();
            }
            var header = document.querySelector('header');
            var offset = header ? parseInt((_a = header.dataset.offset) !== null && _a !== void 0 ? _a : '0') : 0;
            setTimeout(function () {
                window.scrollTo({
                    top: section.getBoundingClientRect().top + window.scrollY - offset,
                    behavior: "smooth",
                });
            }, 200);
        };
        Accordion.prototype.openParentAccordions = function (hash) {
            var id = hash.replace('#', '#accordion-');
            var section = document.querySelector(id);
            if (!section) {
                return;
            }
            var currentElement = section.parentElement;
            while (currentElement) {
                if (currentElement.tagName === 'SECTION' && currentElement.classList.contains('accordion')) {
                    var accordionButton = currentElement.querySelector('button[aria-haspopup]');
                    if (accordionButton) {
                        accordionButton.click();
                    }
                }
                currentElement = currentElement.parentElement;
            }
        };
        return Accordion;
    }());

    exports.Accordion = Accordion;

    return exports;

}({}));
typeof tsBuild === 'function' && tsBuild();})();
